import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Card } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as popupActions } from '~/redux/reducers/popup';
// import SeeMoreCard from './SeeMoreCard';

import { isDusitApp } from '~/utils/helpers';

const SeeMoreCard = dynamic(() => import(/* webpackChunkName: "Card.SeeMoreCard.components" */'./SeeMoreCard'), { loading: () => null });

const StyledLink = styled(Link)`
  @media (max-width: 700px) {
    &:last-child {
      >.card {
        margin-right: 20px;
      }
    }
  }
`;

const enhance = connect(
  ({ session, info, app }) => ({
    sessionData: session.data,
    rates: info.exchangeRates,
    omitBookingFee: true,
    isMobile: app.isMobile,
  }),
  {
    openVideo: tripActions.openVideo,
    openTourCategory: popupActions.openTourCategory,
  }
);
class CarCard extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    data: PropTypes.object,
    sessionData: PropTypes.object,
    omitBookingFee: PropTypes.bool,
    rates: PropTypes.object,
    seeMore: PropTypes.string,
    openVideo: PropTypes.func
  };

  onOpenVideo = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const url = `https://www.youtube.com/embed/${this.props.data.video_url}?autoplay=1`;
    this.props.openVideo(url);
  }

  render() {
    const { isMobile, data, sessionData, omitBookingFee, rates, seeMore } = this.props;
    if (seeMore) {
      return <SeeMoreCard seeMore={seeMore} />;
    }
    const { quantity, currency } = sessionData;
    const isNewTab = !(isMobile || isDusitApp());
    return (
      <StyledLink
        to={data.slug ? `/product/${data.slug}` : '/'}
        className="link"
        target={isNewTab ? '_blank' : '_self'}
        {...isNewTab ? { rel: 'noopener noreferrer' } : {}}
      >
        <Card.CarRentalCard
          data={data}
          quantity={quantity}
          omitBookingFee={omitBookingFee}
          rates={rates}
          currency={currency}
        />
      </StyledLink>
    );
  }
}

export default enhance(CarCard);
